/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingCard/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OnboardingCard({
  children,
  viewPath = "/DesignSystem/OnboardingCard",
  text = "card text"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="OnboardingCard.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="OnboardingCard.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
<div
  data-testid="OnboardingCard.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="OnboardingCard.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</div>
</div>
</React.Fragment>)
}